import eastMidlands from './east-midlands';
import eastOfEngland from './east-of-england';
import humber from './humber';
import northEast from './north-east';
import northWest from './north-west';
import northernIreland from './northern-ireland';
import scotland from './scotland';
import southEast from './south-east';
import southWest from './south-west';
import wales from './wales';
import westMidlands from './west-midlands';
import yorkshire from './yorkshire';
import greaterLondon from './greater-london';
import defaultIndustry from './defaultIndustry';

const data =
  {
    eastMidlands : eastMidlands,
    eastOfEngland : eastOfEngland,
    greaterLondon : greaterLondon,
    humber : humber,
    northEast : northEast,
    northWest : northWest,
    northernIreland : northernIreland,
    scotland : scotland,
    southEast : southEast,
    southWest : southWest,
    wales : wales,
    westMidlands : westMidlands,
    yorkshire : yorkshire,
    defaultIndustry : defaultIndustry
  }

export default data;